import React, { Fragment, Component } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getAllUser } from "../../Graphs/User/listUser";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Spin, notification, Button, Table } from "antd";
import Title from "./Title";
import UserRecordsTable from "./UserRecordsTable";
import { AddUser } from "./AddUser";
import { addUser } from "../../Graphs/User/addUser";
import { checkPermission } from "../AdminUser/CheckPremission";
import { addCorporateUser } from "../../Graphs/User/addCorporateUser";
import {
  ACCESS_DENIED_MESSAGE,
  ACCESS_DENIED_MESSAGE_DESCRIPTION,
} from "../../constant/comman";
import {
  UserOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  LineChartOutlined,
} from "@ant-design/icons";

class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userList: [],
      userListTotal: 0,
      isLoading: false,
      primaryColor: "#4466f2",
      envData: null,
    };
  }

  async componentDidMount() {
    //check the logged-in user has the module view permission else it will redirect to the defined route start
    if (
      !checkPermission(this.props.loginUserData.permissions, "user", "view")
    ) {
      notification["error"]({
        message: ACCESS_DENIED_MESSAGE,
        description: ACCESS_DENIED_MESSAGE_DESCRIPTION,
      });
      this.props.history.replace("/dashboard");
    }
    //check the logged-in user has the module view permission else it will redirect to the defined route end

    try {
      const { setRouteName, setSearchText } = this.props;
      let editPrimaryColor = await localStorage.getItem("primary_color");

      await setRouteName("USER");
      await setSearchText("");

      this.setState({
        isLoading: true,
        primaryColor: editPrimaryColor,
      });

      await this.listUserData();
    } catch (e) {
      notification["error"]({
        message: "User",
        description: "Somwthing went wrong",
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  listUserData = async () => {
    const {
      authToken,
      history,
      setLoginFlag,
      setUserData,
      setUserToken,
      setListUserData,
      setListUserDataTotal,
    } = this.props;

    try {
      let userData = await getAllUser(authToken, 0, 10);

      if (userData.status === 200) {
        //set user data
        // await setListUserData(userData.data.docs);
        await setListUserData(userData.data);
        await setListUserDataTotal(userData.total);

        this.setState({
          // userList: userData.data.docs,
          userList: userData.data,
          userTotal: userData.total,
          userStats: userData.stats || null,
        });
      } else if (userData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      throw e;
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  // addSubmit = async (values) => {
  //   const {
  //     authToken,
  //     history,
  //     setLoginFlag,
  //     setUserData,
  //     setUserToken,
  //     setListUserData,
  //     setListUserDataTotal,
  //   } = this.props;

  //   try {
  //     const { authToken } = this.props;
  //     this.setState({
  //       isLoading: true,
  //     });
  //     console.log(values);
  //     let addUserData = await addUser(authToken, values);

  //     if (addUserData.status === 200) {
  //       await this.listUserData();
  //       notification["success"]({
  //         message: "User Added Successfully",
  //       });
  //     } else if (addUserData.status === 401) {
  //       await setLoginFlag(false);
  //       await setUserData(null);
  //       await setUserToken(null);
  //       history.push(`${process.env.PUBLIC_URL}/login`);
  //     }
  //   } catch (e) {
  //     notification["error"]({
  //       message: "There was a problem in Adding User",
  //     });
  //     console.log("!!!!!!!!e", e);
  //   }
  // };

  addSubmit = async (values) => {
    const {
      authToken,
      history,
      setLoginFlag,
      setUserData,
      setUserToken,
      setListUserData,
      setListUserDataTotal,
      loginUserData, // Add this to props to get user role
    } = this.props;

    try {
      this.setState({
        isLoading: true,
      });

      console.log(values);

      let addUserData;

      if (loginUserData.role === "corporate") {
        addUserData = await addCorporateUser(authToken, values); // Call corporate API
      } else {
        addUserData = await addUser(authToken, values); // Call regular API
      }

      if (addUserData.status === 200) {
        notification["success"]({
          message: addUserData.message || "User Added Successfully",
        });
        window.location.reload();
      } else if (addUserData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      } else {
        this.setState({
          isLoading: false,
        });
        notification["error"]({
          message: addUserData.message || "Failed to add user",
        });
      }
    } catch (e) {
      this.setState({
        isLoading: false,
      });
      notification["error"]({
        message: "There was a problem in Adding User",
      });
      console.log("!!!!!!!!e", e);
    }
  };


  render() {
    const { primaryColor, isLoading, userStats } = this.state;
    const { listUserData, listUserDataTotal, loginUserData } = this.props;

    const users = listUserData || [];
    const totalCount = userStats?.totalCount ?? listUserDataTotal ?? users.length;
    const activeCount = userStats?.activeCount ?? users.filter((u) => u.is_active).length;
    const activePct = userStats?.activePct ?? (users.length ? Math.round((activeCount / users.length) * 100) : 0);

    // Average progress
    const avgProgress = userStats?.avgProgress ?? (users.length
      ? (users.reduce((sum, u) => sum + (u.averageProgress || 0), 0) / users.length).toFixed(1)
      : "0");

    // Total Duration formatted
    const totalDurationSeconds = users.reduce((sum, u) => sum + (u.totalDuration || 0), 0);
    const totalHours = userStats?.totalHours ?? (totalDurationSeconds / 3600).toFixed(1);

    const hexToRgba = (hex, alpha) => {
      if (!hex) return `rgba(68, 102, 242, ${alpha})`;
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    };

    const css = `
      .dashboard-card {
        background: ${primaryColor};
        border-radius: 12px;
        padding: 24px 20px;
        color: #ffffff !important;
        box-shadow: 0 4px 15px ${hexToRgba(primaryColor, 0.15)};
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        overflow: hidden;
        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        min-height: 116px;
      }
      .dashboard-card.clickable {
        cursor: pointer;
      }
      .dashboard-card.clickable:hover {
        transform: translateY(-6px);
        box-shadow: 0 12px 24px ${hexToRgba(primaryColor, 0.3)};
      }
      .dashboard-card .card-label {
        font-size: 14px;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.8) !important;
        margin: 0;
      }
      .dashboard-card .card-count {
        font-size: 28px;
        font-weight: 700;
        margin-top: 4px;
        color: #ffffff !important;
      }
      .dashboard-card .card-subtext {
        font-size: 12px;
        opacity: 0.9;
        margin-top: 2px;
        color: rgba(255, 255, 255, 0.9) !important;
      }
      .dashboard-card .card-icon {
        color: #ffffff !important;
        opacity: 0.15;
        position: absolute;
        right: -10px;
        bottom: -10px;
        font-size: 80px !important;
        width: 80px;
        height: 80px;
        transition: all 0.3s ease;
      }
      .dashboard-card.clickable:hover .card-icon {
        opacity: 0.35;
        transform: scale(1.15) rotate(-10deg);
      }
    `;

    return (
      <Fragment>
        <style>{css}</style>
        <Title parent="User" title="Users" />

        {/* Statistics Cards Panel */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: "20px",
          padding: "10px 14px 20px 14px",
          width: "100%"
        }}>
          {/* Card 1 */}
          <div className="dashboard-card clickable">
            <div>
              <div className="card-label">Total Users</div>
              <div className="card-count">{totalCount}</div>
            </div>
            <UserOutlined className="card-icon" />
          </div>

          {/* Card 2 */}
          <div className="dashboard-card clickable">
            <div>
              <div className="card-label">Active Status</div>
              <div className="card-count">{activePct}%</div>
              <div className="card-subtext">{activeCount} active in current page</div>
            </div>
            <CheckCircleOutlined className="card-icon" />
          </div>

          {/* Card 3 */}
          <div className="dashboard-card clickable">
            <div>
              <div className="card-label">Avg Progress</div>
              <div className="card-count">{avgProgress}%</div>
              <div className="card-subtext">Across loaded users</div>
            </div>
            <LineChartOutlined className="card-icon" />
          </div>

          {/* Card 4 */}
          <div className="dashboard-card clickable">
            <div>
              <div className="card-label">Learning Hours</div>
              <div className="card-count">{totalHours} hrs</div>
              <div className="card-subtext">Time spent by loaded users</div>
            </div>
            <ClockCircleOutlined className="card-icon" />
          </div>
        </div>

        <div
          style={{
            marginTop: "10px",
            display: "inline-block",
            width: "100%",
            marginBottom: "10px",
            paddingLeft: "14px",
            paddingRight: "55px",
          }}
        >
          <div style={{ float: "left", cursor: "pointer" }}>
            <AddUser primaryColor={primaryColor} onSubmit={this.addSubmit} Token={this.props.authToken} LoginData={this.props.loginUserData} />
          </div>
        </div>

        <div className="container-fluid">
          {isLoading ? (
            <div style={{ marginLeft: "20px" }}>
              <Spin
                size="large"
                style={{ marginLeft: "480px", marginTop: "130px" }}
              />
            </div>
          ) : (
            <div>
              <UserRecordsTable
                userList={listUserData}
                userTotal={listUserDataTotal}
                primaryColor={primaryColor}
              />
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  loginUserData: state.auth.loginUserData,
  listUserData: state.user.listUserData,
  listUserDataTotal: state.user.listUserDataTotal,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setLoginFlag: (flag) => {
      dispatch({
        type: "SET_LOGIN_FLAG",
        flag: flag,
      });
    },
    setUserData: (userData) => {
      dispatch({
        type: "SET_USER_DATA",
        userData: userData,
      });
    },
    setUserToken: (authToken) => {
      dispatch({
        type: "SET_USER_AUTHTOKEN",
        authToken: authToken,
      });
    },
    setListUserData: (listUserData) => {
      dispatch({
        type: "SET_LIST_USER_DATA",
        listUserData: listUserData,
      });
    },
    setListUserDataTotal: (listUserDataTotal) => {
      dispatch({
        type: "SET_LIST_USER_DATA_TOTAL",
        listUserDataTotal: listUserDataTotal,
      });
    },
    setRouteName: (routeName) => {
      dispatch({
        type: "SET_ROUTE_NAME",
        routeName: routeName,
      });
    },
    setSearchText: (searchText) => {
      dispatch({
        type: "SET_SEARCH_TEXT",
        searchText: searchText,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(User));
